<script lang="ts" setup>
import { mergeProps } from 'vue'
import type { VCard } from 'vuetify/components'

const {
  size = 186,
  rotate = undefined,
  border = undefined,
  card = {},
} = defineProps<{
  src: string
  type: 'image' | 'video'
  size?: number
  rotate?: number
  border?: number
  card?: VCard['$props']
}>()
</script>

<template>
  <v-hover>
    <template #default="{ isHovering, props: hoverProps }">
      <v-card
        class="position-relative"
        :class="{
          'v-card-bordered': !!border,
        }"
        v-bind="mergeProps($attrs, card, hoverProps, {
          height: size,
          width: size,
          image: type === 'image' ? src : undefined,
        })"
        :style="{
          transform: rotate ? `rotate(${rotate}deg)` : undefined,
          outline: border ? undefined : (isHovering ? '2px solid rgb(var(--v-theme-accent))' : 'none'),
          boxShadow: isHovering ? '0 20px 30px rgba(0, 0, 0, 0.15)' : '0 10px 20px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.32s ease',
          borderRadius: '20px',
          '--v-card-border': border ? `${border}px` : undefined,
        }"
      >
        <csm-ui-video
          v-if="type === 'video'"
          :aspect-ratio="1"
          :url="{ 'video/mp4': src }"
          :style="{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
          }"
        />
        <slot />
      </v-card>
    </template>
  </v-hover>
</template>

<style scoped lang="scss">
.v-card {
  box-sizing: border-box;
  &.v-card-bordered {
    overflow: visible;

    &::before {
      content: '';
      position: absolute;
      top: calc(var(--v-card-border) * -1);
      left: calc(var(--v-card-border) * -1);
      right: calc(var(--v-card-border) * -1);
      bottom: calc(var(--v-card-border) * -1);
      z-index: 5;
      border-radius: inherit;
      border: var(--v-card-border) solid #fff;
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
